export default {
	WHOLE_DAYS: 'Whole Days',
	HOURS: 'Hours',
};
